import React from 'react'
import './titulo.css'
import { Typography } from '@material-ui/core'
const Titulo = (props)=>( <Typography variant="h3" component="h2" className="titulo" align={ props.align ?? props.align } style={{color:props.color}}>{props.texto}</Typography>)

export default Titulo